var exports = {
  "K": "icon__IeDwva",
};

module.exports = exports;
